import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37e49140"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ub ub-ver flow-log-div" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_table_wrapper = _resolveComponent("table-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_table_wrapper, {
      pagination: _ctx.pagination,
      onOnTableChange: _ctx.onTableChange,
      loading: _ctx.loading,
      showCheckbox: false,
      dataSource: _ctx.dataSource,
      columns: _ctx.columns
    }, {
      nextTenantUserRealName: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(Array.isArray(record.nextTenantUserRealName)
          ? record.nextTenantUserRealName.join("，")
          : record.nextTenantUserRealName), 1)
      ]),
      _: 1
    }, 8, ["pagination", "onOnTableChange", "loading", "dataSource", "columns"])
  ]))
}